import React from "react";

const WarningIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={13}>
            <path
                fill="#004DA6" // Changed the color according to the Spire Prod
                fillRule="nonzero"
                d="M15.89 11.502 8.615.325C8.481.123 8.25 0 8 0s-.481.123-.615.325L.111 11.502a.677.677 0 0 0-.016.717.734.734 0 0 0 .649.352h14.549a.726.726 0 0 0 .62-.368.673.673 0 0 0-.023-.7zm-7.145-1.026H7.291V9.079h1.454v1.397zm0-2.795H7.291V4.188h1.454v3.493z"
            />
        </svg>
    );
};

export default WarningIcon;
